import { render, staticRenderFns } from "./kw_information_card.vue?vue&type=template&id=1c43a1fa&scoped=true&"
import script from "./kw_information_card.vue?vue&type=script&lang=js&"
export * from "./kw_information_card.vue?vue&type=script&lang=js&"
import style0 from "./kw_information_card.vue?vue&type=style&index=0&id=1c43a1fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c43a1fa",
  null
  
)

component.options.__file = "kw_information_card.vue"
export default component.exports